<template>
  <div class="page-content pointRecord">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>信用积分</el-breadcrumb-item>
      <el-breadcrumb-item>我的扣分记录</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form-flex flex_between" :label-width="formLabelWidth">
        <el-form-item label="平台">
          <el-select
            placeholder="请选择"
            v-model="searchform.platform"
            filterable
            size="small"
            clearable
          >
            <el-option label="全部" value></el-option>
            <el-option
              v-for="(item,i) in plateList"
              :key="i"
              :label="item.dictName"
              :value="item.dictCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称">
          <el-input placeholder="请输入" size="small" v-model="searchform.shopname" clearable></el-input>
        </el-form-item>
        <el-form-item label="扣分时间">
          <el-date-picker
            v-model="committime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="举报ID">
          <el-input placeholder="请输入" size="small" v-model="searchform.reportid" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品信息">
          <el-input placeholder="请输入" size="small" v-model="searchform.productname" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="searchTable">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <section class="seaerch-wrapper">
      <div class="margin_bottom20">
        <el-button size="small" class="search-btn1" @click="downLoad">下载数据</el-button>
      </div>
      <el-table
        ref="multipleTable"
        header-row-class-name="data-table-header-style"
        :data="tableData"
        style="width: 100%"
        @row-click="rowClick"
        v-loading="tableLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column label="序号" width="60" type="index"></el-table-column>
        <el-table-column label="违规信息">
          <template slot-scope="scope">
              <delReportInfo :info="scope.row" :reportTime='false'></delReportInfo>
          </template>
        </el-table-column>
        <el-table-column label="扣分/附加处罚">
          <template slot-scope="scope">
            <div>扣分值：{{scope.row.points}}分</div>
            <div>附加处罚：{{scope.row.punish}}</div>
            <div>扣分说明：{{scope.row.pointsexplains}}</div>
          </template>
        </el-table-column>
        <el-table-column label="扣分时间">
          <template slot-scope="scope">扣分时间：{{scope.row.pointtime|fullTime}}</template>
        </el-table-column>
      </el-table>
      <Pagination
        @onChange="getPointPageByShop"
        class="pagination"
        :total="totalPage"
        :pagination="pagination"
        style="text-align:right;margin:20px 0;"
      />
      <rightInfo ref="refRightInfo"></rightInfo>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { getSinceThreeMonth } from "@/libs/date";
import Pagination from "components/pagination/pagination";
import { fetchGet, fetchPost, fetchGetDown } from "@/libs/reqCommon";
import rightInfo from "./rightInfo";
import delReportInfo from '../common/delReportInfo'
export default {
  data() {
    return {
      searchform: {},
      productData: [],
      formLabelWidth: "100px",
      committime: [],
      tableData: [],
      totalPage: 0,
      pagination: {
        size: 10,
        current: 1
      },
      tableLoading:true
    };
  },
  computed: {
    ...mapGetters(["plateList"])
  },
  components: { Pagination, rightInfo,delReportInfo },
  created() {
    this.committime = getSinceThreeMonth();
    this.reqPlateList();
    this.getPointPageByShop();
  },
  methods: {
    ...mapActions(["reqPlateList", "getById"]),
    downLoad() {
      let data = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.size,
        ...this.searchform
      };
      //下载
      fetchGetDown(
        "hcm/hcmReport/downloadPointPageByShop",
        data,
        "我的扣分记录"
      );
    },
    getPointPageByShop() {
      this.tableLoading=true
      let data = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.size,
        ...this.searchform
      };
      fetchGet("hcm/hcmReport/getPointPageByShop", data).then(res => {
        this.tableLoading=false
        if (res.status == "10000") {
          this.tableData = res.data.content;
          this.totalPage = res.data.totalElements;
        }
      }).catch(()=>{
          this.tableLoading=false
      })
    },
    async rowClick(row) {
      await this.getById(row.reportid);
      this.$refs.refRightInfo.ifshow = true;
    },
    searchTable() {
      this.tableLoading=true
      this.pagination = {
        size: 10,
        current: 1
      };
      this.searchform.starttime = this.committime
        ? this.committime[0].slice(0, 10)
        : "";
      this.searchform.endtime = this.committime
        ? this.committime[1].slice(0, 10)
        : "";
      this.getPointPageByShop();
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
@import "src/style/tableCommon";
.pointRecord {
  .el-cascader {
    width: 100%;
  }
  .el-drawer__header {
    // margin-bottom: 0;
  }
}
</style>